module.exports = __webpack_public_path__ + "static/img/163-80.8e25a873.svg";